export default __webpack_public_path__ + "static/media/Plant_Render 1.fd771ede.jpg";